export default __webpack_public_path__ + "static/media/logo-black.d300383a.png";